import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpShop'

export const couponList = (params = '') => Http.get(`/coupons${serialize(params)}`)
export const couponCreate = data => Http.post('/coupons', data)
export const couponUpdate = (id, data) => Http.put(`/coupons/${id}`, data)
export const couponDestroy = id => Http.delete(`/coupons/${id}`)
